import { useEffect } from "react";
import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function Impressum() {
  useEffect(() => { document.title = "Impressum – Englputzeder Tippspiel"; }, []);

  return (
    <LegalLayout title="Impressum">
      <LegalSection title="Medieninhaber & Diensteanbieter">
        <p className="text-foreground font-semibold">Englputzeder GmbH</p>
        <p>Furt 44<br />4754 Andrichsfurt<br />Österreich</p>
        <p>Tel.: <a href="tel:+43775020194" className="underline">+43 7750-20194</a><br />
        E-Mail: <a href="mailto:anfrage@englputzeder.at" className="underline">anfrage@englputzeder.at</a></p>
      </LegalSection>

      <LegalSection title="Unternehmensdaten">
        <p>Geschäftsführer: Dominik Englputzeder</p>
        <p>UID-Nummer: ATU82555539</p>
        <p>Firmenbuchnummer: FN 659267k</p>
        <p>Firmenbuchgericht: Landesgericht Ried im Innkreis</p>
        <p>Unternehmensgegenstand: Handel mit Waren aller Art, insbesondere Bodenbeläge & Wohnaccessoires</p>
      </LegalSection>

      <LegalSection title="Aufsichtsbehörde / Gewerberecht">
        <p>Bezirkshauptmannschaft Ried im Innkreis</p>
        <p>Anwendbare Rechtsvorschriften: Gewerbeordnung (GewO), abrufbar unter <a href="https://www.ris.bka.gv.at" target="_blank" rel="noopener noreferrer" className="underline">ris.bka.gv.at</a></p>
        <p>Mitglied der Wirtschaftskammer Oberösterreich</p>
      </LegalSection>

      <LegalSection title="Online-Streitbeilegung">
        <p>Plattform der EU-Kommission zur Online-Streitbeilegung: <a href="https://ec.europa.eu/odr" target="_blank" rel="noopener noreferrer" className="underline">ec.europa.eu/odr</a></p>
        <p>Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle weder verpflichtet noch bereit.</p>
      </LegalSection>

      <LegalSection title="Haftungsausschluss">
        <p>Diese Tippspiel-App wird ständig aktualisiert und überprüft. Trotz aller Sorgfalt können sich Daten zwischenzeitlich verändert haben. Eine Haftung oder Garantie für die Aktualität, Richtigkeit und Vollständigkeit der zur Verfügung gestellten Informationen — insbesondere Spielergebnisse, Tabellenstände und Punkteberechnungen — kann daher nicht übernommen werden.</p>
        <p>Die Englputzeder GmbH veranstaltet das Tippspiel als kostenloses Geschicklichkeitsspiel. Es besteht kein Rechtsanspruch auf Teilnahme oder Gewinnauszahlung außerhalb der Teilnahmebedingungen.</p>
      </LegalSection>
    </LegalLayout>
  );
}
